import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import { useSelector } from 'react-redux'

// Ui
import Input from 'ui/Form/Input'
import Text from 'ui/Text'
import Button from 'ui/Button'
import Avatar from 'ui/Avatar'
import Row from 'ui/Row'
import Col from 'ui/Col'

import './AvatarPicker.scss'

const AvatarPicker = ({ disabled, errors, onChange, name, value, accept }) => {
  const inputFileRef = useRef()
  const user = useSelector((state) => state.auth.user)

  const onInput = (e) => {
    e.preventDefault()
    if (e.target.files.length > 0) {
      onChange(e.target.files[0], name)
    }
  }

  const isError = () => name in errors && errors.avatar !== null

  return (
    <Row className="avatar-picker mb-2">
      <Col sm={2} xs={3}>
        <Avatar name={user.email} image={user.avatar} />
      </Col>
      <Col md={7} sm={{ span: 'auto' }}>
        <div className="wrapper-picker">
          <Input
            name={name}
            type="text"
            label={disabled ? 'Profile photo' : 'Select a photo'}
            disabled={disabled}
            placeholder="Select a photo"
            value={value instanceof File ? value?.name : value}
          />
          {!disabled && (
            <Button onClick={() => inputFileRef.current.click()}>
              Select photo
            </Button>
          )}
        </div>
        <input
          accept={accept}
          ref={inputFileRef}
          hidden={true}
          type="file"
          onChange={onInput}
        />
        <Text
          color={isError() ? '#d53232' : '#606060'}
          size="14px"
          paddingTop="5px"
          paddingBottom="5px"
          bold={isError()}
        >
          Must be max 3MB and .jpg or .png
        </Text>
      </Col>
    </Row>
  )
}
AvatarPicker.propTypes = {
  disabled: PropTypes.bool,
  errors: PropTypes.object,
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  accept: PropTypes.string,
}

AvatarPicker.defaultProps = {
  disabled: false,
  errors: {},
  onChange: () => {},
  name: '',
  value: '',
  accept: '',
}
export default AvatarPicker
